import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Clock, MapPin, ArrowRight, MessageCircle } from 'lucide-react';

export const TourCard = ({ tour }) => {
  const { language } = useLanguage();

  const getWhatsAppLink = () => {
    const tourName = language === 'en' ? tour.name : tour.nameEs;
    const message = `Hi! I'm interested in the ${tourName}. Please share more details.`;
    return `https://wa.me/917827884419?text=${encodeURIComponent(message)}`;
  };

  return (
    <div className="tour-card group flex flex-col h-full">
      {/* Image Link */}
      <Link to={`/tours/${tour.slug}`} className="tour-card-link block relative overflow-hidden rounded-t-lg flex-shrink-0 aspect-video">
        <img
          src={tour.heroImage}
          alt={`${language === 'en' ? tour.name : tour.nameEs} - Peace of Mind Trips`}
          className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-700"
        />
        {/* Overlay */}
        <div className="tour-card-overlay absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-100 group-hover:opacity-90 transition-opacity duration-300">
          <div className="absolute bottom-4 left-4 right-4">
            <div className="flex items-center space-x-2 mb-2">
              <Clock className="h-4 w-4 text-[#C4B5A0]" />
              <span className="text-white text-sm">{language === 'en' ? tour.duration : tour.durationEs}</span>
            </div>
            <h3 className="font-serif text-2xl text-white mb-1 line-clamp-2 max-h-16">
              {language === 'en' ? tour.name : tour.nameEs}
            </h3>
            <p className="text-white/90 text-sm italic line-clamp-2 max-h-10">
              {language === 'en' ? tour.tagline : tour.taglineEs}
            </p>
          </div>
        </div>
        
        {/* View Itinerary Hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[#C4B5A0]/20 backdrop-blur-sm">
          <span className="bg-white text-[#2C2C2C] px-6 py-3 rounded-md font-medium flex items-center space-x-2">
            <span>View Itinerary</span>
            <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </Link>

      {/* Card Content */}
      <div className="p-6 bg-white rounded-b-lg shadow-lg flex-grow flex flex-col">
        {/* Price on Request */}
        <div className="mb-4">
          <p className="text-lg font-medium text-[#6B4E37] italic">
            Price on request
          </p>
        </div>

        {/* CTAs */}
        <div className="flex flex-col gap-3 mt-auto">
          <Link to={`/tours/${tour.slug}`}>
            <Button className="w-full bg-[#C4B5A0] hover:bg-[#6B4E37] text-white">
              Request Itinerary
            </Button>
          </Link>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white flex items-center justify-center space-x-2">
              <MessageCircle className="h-4 w-4" />
              <span>Book on WhatsApp</span>
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};